<template>
    <div class="bg-white px-3 index" >
        <div class="ibox-content filter">
            <el-row :gutter="30">
                <el-col :span="4">
                    <el-card class="box-card" :style='cardStyle' shadow="never" v-loading="loading">
                        <el-tree :data="lef_data" :props="defaultProps" class="listtree" @node-click="handleNodeClick">
                        </el-tree>
                    </el-card>
                </el-col>
                <el-col :span="20">
                    <el-card class="box-card" shadow="never">
                        <div slot="header" class="clearfix">
                            <div class="flex">
                                <div>科普文章</div>
                                <div>
                                    <el-button type="primary" size="mini" v-if='lm_id'
                                        icon="el-icon-circle-plus-outline" @click="handleAdd">新增</el-button>
                                    <el-button size="mini" type="primary" v-if='lm_id' @click="getjbzsxx()">疾病知识
                                    </el-button>
                                </div>
                            </div>
                        </div>

                        <el-table :data="tableData" border :height="height" class="tableLimit" v-loading="loadings">
                            <el-table-column prop="title" label="标题" show-overflow-tooltip width="200">
                            </el-table-column>
                            <el-table-column prop="content" label="内容" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip width="200">
                            </el-table-column>
                            <el-table-column label="操作" width="150" align="center">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                                        @click="handleEdit(scope.row,scope.$index)"></el-button>
                                    <el-button size="mini" type="danger" icon="el-icon-delete"
                                        @click="handleDelet(scope.row,scope.$index)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="list-footer">
                            <div class="foot-bg"></div>
                            <div class="block page_r">
                                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                    :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                                    layout="total, sizes, prev, pager, next, jumper" :total="count">
                                </el-pagination>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>


        <!--  -->
        <el-dialog title="科普文章设置" :visible.sync="dialogVisible_kpwz" center top="20px" width="60%"
            :close-on-click-modal="false" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" :style="nrStyle">
                <el-form :model="ruleForm_Kpwz" :rules="rule" ref="ruleForm_Kpwz" label-width="150px"
                    class="demo-ruleForm_Kpwz">
                    <div class="u-f">
                        <el-form-item label="诊疗中心" prop='label_value'>
                            <el-select v-model="ruleForm_Kpwz.label_value" placeholder="请选择" size="small" filterable
                                clearable @change="getzlzxbz">
                                <el-option v-for="item in label_optioned" :key="item.id" :label="item.type_name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="疾病" prop='bz_value'>
                            <el-select v-model="ruleForm_Kpwz.bz_value" placeholder="请选择" size="small" filterable
                                clearable>
                                <el-option v-for="item in bz_optioned" :key="item.id" :label="item.content_name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item label="客户关注" prop='khgz_value'>
                        <el-select v-model="ruleForm_Kpwz.khgz_value" placeholder="请选择" size="small" filterable
                            clearable>
                            <el-option v-for="item in khgz_optioned" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标题" prop='sz_bt'>
                        <el-input v-model="ruleForm_Kpwz.sz_bt" size="small" class="zwidth"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" prop='sz_nr'>
                        <el-input v-model="ruleForm_Kpwz.sz_nr" type="textarea" :rows="4" placeholder="请输入内容"
                            class="zwidth"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="ruleForm_Kpwz.sz_sort" size="small" type="number" class="zwidth"> </el-input>
                    </el-form-item>
                    <el-form-item label="上传文件">
                        <el-upload class="upload-demo zwidth" :headers="{ token:$store.state.user.token }"
                            :data="{ image_class_id:'73',file_type:'0' }" action="/admin/uploadFile"
                            :on-preview="handlePreview" :file-list="fileList" :on-success="handleSuccess"
                            :on-remove="handleRemove" ref="upload" name='img'>
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit_kpwz('ruleForm_Kpwz')" size="small" type="primary" :loading="subloading">提 交
                </el-button>
                <el-button @click="dialogVisible_kpwz = false" size="small">取 消</el-button>
            </span>
        </el-dialog>

        <!--  -->

        <el-dialog title="疾病知识设置" :visible.sync="dialogVisible" center top="20px" width="60%"
            :close-on-click-modal="false" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" :style="nrStyle">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <div class="u-f">
                        <el-form-item label="诊疗中心" prop='label_value'>
                            <el-select v-model="ruleForm.label_value" placeholder="请选择" size="small" filterable  @change="getzlzxbzed"
                                clearable>
                                <el-option v-for="item in label_optioned" :key="item.id" :label="item.type_name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="疾病" prop='bz_value'>
                            <el-select v-model="ruleForm.bz_value" placeholder="请选择" size="small" filterable
                                clearable>
                                <el-option v-for="item in bz_options" :key="item.id" :label="item.content_name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                    <el-form-item label="客户关注" prop='khgz_value'>
                        <el-select v-model="ruleForm.khgz_value" placeholder="请选择" size="small" filterable clearable>
                            <el-option v-for="item in khgz_optioned" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标题" prop='sz_bt'>
                        <el-input v-model="ruleForm.sz_bt" size="small" class="zwidth"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" prop='sz_nr'>
                        <el-input v-model="ruleForm.sz_nr" type="textarea" :rows="4" placeholder="请输入内容" class="zwidth">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="ruleForm.sz_sort" size="small" type="number" class="zwidth"> </el-input>
                    </el-form-item>
                    <el-form-item label="上传文件">
                        <el-upload class="upload-demo zwidth" :headers="{ token:$store.state.user.token }"
                            :data="{ image_class_id:'73',file_type:'0' }" action="/admin/uploadFile"
                            :on-preview="handlePreview" :file-list="fileList" :on-success="handleSuccess"
                            :on-remove="handleRemove" ref="upload" name="img" list-type="picture">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-form-item>
                     <el-form-item label="疾病信息">
                        <el-select v-model="ruleForm.jbxx_value" placeholder="请选择" size="small" filterable clearable>
                            <el-option v-for="item in jbxx_options" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <el-button type="primary" @click="addJB" size="small" style="margin-left:10px">添加</el-button>
                     </el-form-item>

                      <!-- <wang-editor @editorContent="getEditorContent" /> -->

                     <div v-for="(item,index) in list" :key="index">
                          <el-form-item :label="item.dimension_name" prop='lb_content'>
                            <tinymce ref="editor" v-model="item.dimension_content"
                                toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
                            <el-button type="primary" @click="delJB(index)" size="small" style="margin-left:10px">删除</el-button>
                            </el-form-item>
                          <!-- <wang-editor @editorContent="getEditorContent" /> -->

                           <!-- <el-form-item :label="item.dimension_name">
                                <el-input v-model="item.dimension_content" type="textarea" :rows="4" placeholder="请输入内容" class="zwidth"> </el-input>
                                <el-button type="primary" @click="delJB(index)" size="small" style="margin-left:10px">删除</el-button>
                           </el-form-item> -->
                     </div>

                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>



    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    // import WangEditor from "./editorTemplate";
    export default {
        components: {
            // WangEditor,
            tinymce
        },
        data() {
            return {
                show: true,
                label_optioned: [],
                bz_optioned: [],
                bz_options:[],
                khgz_optioned: [],
                // left
                loading: false,
                cardStyle: {
                    height: null,
                    "overflow": "auto"
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                lef_data: [],
                // right
                height: null,
                loadings: false,
                lm_id: '',
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                // 
                dialogVisible: false,
                dialogVisible_kpwz: false,
                subloading: false,
                eid: '',
                fileList: [],
                upList: [],
                nrStyle: {
                    height: null,
                    "overflow": "auto"
                },
                ruleForm: {
                    sz_bt: '',
                    sz_nr: '',
                    sz_sort: 50,
                    sz_bzjj: 2,
                    label_value: '',
                    khgz_value: '',
                    bz_value: '',
                    jbxx_value:'',
                },
                jbxx_options:[],
                list:[],
                rule: {
                    sz_bt: [{
                        required: true,
                        message: '请填写标题',
                        trigger: 'blur'
                    }],
                    sz_nr: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],
                },
                ruleForm_Kpwz: {
                    sz_bt: '',
                    sz_nr: '',
                    sz_sort: 50,
                    sz_bzjj: 2,
                    label_value: '',
                    khgz_value: '',
                    bz_value: '',
                },

                // wangeditor编辑器的内容
                    content: "",
                    editorData: "",
            }
        },

        mounted() {
            let that = this
            that.getHeight()
            that.getlmxx()
            that.getbzxx()
            that.getkhgzxx()
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        methods: {
            getHeight() {
                let that = this
                that.cardStyle.height = window.innerHeight - 140 + 'px'
                that.height = window.innerHeight - 280 + 'px'
                window.onresize = () => {
                    that.cardStyle.height = window.innerHeight - 140 + 'px'
                    that.height = window.innerHeight - 280 + 'px'
                }
            },
            // 获取诊疗中心
            getbzxx() {
                let that = this
                that.label_optioned = []
                axios
                    .post("/admin/getZlzxBz", {}, {
                        token: true
                    })
                    .then(response => {
                        that.label_optioned = response.data.data
                    })
                    .catch(error => {})
            },
            getzlzxbz() {
                this.ruleForm_Kpwz.bz_value = ''
                this.label_optioned.forEach(element => {
                    if (element.id == this.ruleForm_Kpwz.label_value) {
                        this.bz_optioned = element.dictionary_model_type_content
                    }
                });

            },
            getzlzxbzed(){
                this.label_optioned.forEach(element => {
                    if (element.id == this.ruleForm.label_value) {
                        this.bz_options = element.dictionary_model_type_content
                    }
                });
            },
            // 获取客户关注信息
            getkhgzxx() {
                let that = this
                that.khgz_optioned = []
                axios
                    .post("/admin/customerFocus", {}, {
                        token: true
                    })
                    .then(response => {
                        that.khgz_optioned = response.data.data
                    })
                    .catch(error => {})
            },
            // 获取数据
            getlmxx() {
                let that = this
                that.loading = true
                that.lef_data = []
                this.lm_id = ''
                axios
                    .post("/admin/KkysKnowledgeDisease/showDiseaseList", {
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.lef_data = response.data.data
                    })
                    .catch(error => {})
            },
            clear_jbzs() {
                let that = this
                that.ruleForm.sz_bt = ''
                that.ruleForm.sz_nr = ''
                that.upList = []
                that.fileList = []
                that.ruleForm.label_value = ''
                that.ruleForm.khgz_value = ''
                that.ruleForm.bz_value = ''
            },
             getinfoxx(){
                  let that = this
                  axios
                    .post("/admin/knowledgecategory/categorySelect", {
                    }, {
                        token: true
                    })
                    .then(response => {
                       that.jbxx_options=response.data.data
                    })
                    .catch(error => {})
            },
            addJB(){
                let that=this
                if(this.ruleForm.jbxx_value=='') return  that.$message('请选择疾病信息');
                if(this.list.length>0){
                    var  flag=false
                    this.list.forEach((element)=>{
                        if(element.dimension_id==this.ruleForm.jbxx_value){
                            flag=true
                        }
                    })
                }
                if(flag) return that.$message('不能选择重复的信息');
                var obj={dimension_id:'',dimension_content:'',dimension_name:''}
                obj.dimension_id=this.ruleForm.jbxx_value
                obj.dimension_name=this.jbxx_options.find(element => {
                    return element.id==this.ruleForm.jbxx_value
                }).name
                obj.dimension_content=''
                this.list.push(obj)
            },
            delJB(index){
                this.list.splice(index,1)
            },
            // 获取疾病知识信息
            getjbzsxx() {
                let that = this
                this.list=[]
                that.getinfoxx()
                that.clear_jbzs()
                axios
                    .post("/admin/knowledgearticle/diseaseKnowledge", {
                        column_id: that.lm_id
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            that.dialogVisible = true
                            var data = response.data.data
                            if (data) {
                                that.eid = data.id
                            } else {
                               return that.eid = ''
                            }
                            that.ruleForm.sz_bt = data.title
                            that.ruleForm.sz_nr = data.content
                            that.ruleForm.sz_sort = data.sort
                            that.ruleForm.sz_bzjj = data.if_disease
                            that.ruleForm.label_value = data.label_code ? Number(data.label_code) : ""
                            that.getzlzxbzed()
                            that.ruleForm.bz_value = data.disease_code ? Number(data.disease_code) : ''
                            that.ruleForm.khgz_value = data.customer_focus_code?Number(data.customer_focus_code):""
                            that.list=data.dimension
                            that.fileList = data.file_info?data.file_info:[]
                            that.upList = data.file_info.map(element => {
                                return {
                                    response: {
                                        data: element
                                    }
                                }
                            })
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            handleNodeClick(data) {
                let that = this
                that.lm_id = data.id
                that.getlist()
            },
            // 获取右侧数据
            getlist() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.getnr()
            },
            getnr() {
                let that = this
                that.loadings = true
                axios
                    .post("/admin/knowledgearticle/list", {
                        column_id: that.lm_id,
                        type: 'kpwz',
                        page: that.currentPage,
                        page_count: that.pagesize,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loadings = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.getlist()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.getlist()
            },
            // 添加
            handleAdd() {
                let that = this
                that.dialogVisible_kpwz = true
                that.eid = '0'
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm_Kpwz.sz_bt = ''
                that.ruleForm_Kpwz.sz_nr = ''
                that.upList = []
                that.fileList = []
                that.ruleForm_Kpwz.label_value = ''
                that.ruleForm_Kpwz.khgz_value = ''
                that.ruleForm_Kpwz.bz_value = ''
            },
           
            // 提交
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                          var arr = that.upList.map(ele => ele.response.data)
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/knowledgearticle/diseaseUpdate"
                        } else {
                            urls = "/admin/knowledgearticle/diseaseSave"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                column_id: that.lm_id,
                                title: that.ruleForm.sz_bt,
                                content: that.ruleForm.sz_nr,
                                
                                file: arr,
                                author: this.user.id,
                                px: that.ruleForm.sz_sort,
                                if_disease: '1',
                                label_code: that.ruleForm.label_value,
                                disease_code: that.ruleForm.bz_value,
                                customer_focus_code: that.ruleForm.khgz_value,
                                dimension:this.list
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.getlist()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {})
                    } else {
                        return false;
                    }
                });
            },
            // 提交
            submit_kpwz(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        var arr = that.upList.map(ele => ele.response.data)
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/knowledgearticle/update"
                        } else {
                            urls = "/admin/knowledgearticle/save"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                column_id: that.lm_id,
                                title: that.ruleForm_Kpwz.sz_bt,
                                content: that.ruleForm_Kpwz.sz_nr,
                                file: arr,
                                author: this.user.id,
                                px: that.ruleForm_Kpwz.sz_sort,
                                if_disease: '2',
                                label_code: that.ruleForm_Kpwz.label_value,
                                disease_code: that.ruleForm_Kpwz.bz_value,
                                customer_focus_code: that.ruleForm_Kpwz.khgz_value,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible_kpwz = false
                                    that.getlist()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            // 科普文章编辑
            handleEdit(row, index) {
                let that = this
                that.eid = row.id
                that.dialogVisible_kpwz = true
                that.form_clear()
                axios
                    .post("/admin/knowledgearticle/read", {
                        id: that.eid,
                        type: "editinfo"
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        that.ruleForm_Kpwz.sz_bt = data.title
                        that.ruleForm_Kpwz.sz_nr = data.content
                        that.ruleForm_Kpwz.sz_sort = data.sort
                        that.ruleForm_Kpwz.label_value = data.label_code ? Number(data.label_code) : ""
                        that.getzlzxbz()
                        that.ruleForm_Kpwz.bz_value = data.disease_code ? Number(data.disease_code) : ''
                        that.ruleForm_Kpwz.khgz_value = data.customer_focus_code ? Number(data
                            .customer_focus_code) : ""
                        that.fileList = data.file_info?data.file_info:[]
                        that.upList = data.file_info.map(element => {
                            return {
                                response: {
                                    data: element
                                }
                            }
                        })
                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/knowledgearticle/del", {
                            id: row.id,
                        },{token:true})
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getlist()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 上传成功
            handleSuccess(response, file, fileList) {
                let that = this
                if (response.code == "200") {
                    that.upList = fileList
                    this.$message({
                        type: 'success',
                        message: '上传成功!'
                    });
                } else {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                }
            },
            // 上传移除
            handleRemove(file, fileList) {
                let that = this
                that.upList = fileList
            },
            handlePreview(file) {
                let that = this
                if (that.eid !== '0') {
                    if (file.file_url) {
                        window.open(file.file_url)
                    }
                }
            },
            // 获取编辑器的内容
            getEditorContent(data) {
                this.editorData = data.replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi,'').replace(/<[^>]+?>/g,'').replace(/\s+/g,' ').replace(/ /g,' ').replace(/>/g,' ');
            }
        },
    }
</script>

<style scoped>
    .flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .el-card__header {
        padding: 8px 20px !important;
    }

    .zwidth {
        max-width: 80% !important;
    }

    .listtree .el-tree-node.is-checked.is-expanded>.el-tree-node__content {
        background-color: #008080 !important;
        color: #ffffff !important;
    }

    .listtree .el-tree-node.is-current>.el-tree-node__content {
        background-color: #008080 !important;
        color: #ffffff !important;
    }
</style>